import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { EventsApiQuery } from "../utils/eventFilterApi";
import type { Event, PaginatedEvents } from "./apiTypes";

const prodUrl = "https://sfcalendar.azurewebsites.net/";
let baseUrl = prodUrl;
const dev = true;
if (dev && !import.meta.env.PROD) {
    baseUrl = "http://127.0.0.1:8001/";
}

function buildEventsPath(query: EventsApiQuery): string {
    const sp = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
        if (value !== undefined && value !== "") sp.set(key, value);
    }
    const qs = sp.toString();
    return qs ? `/api/events/?${qs}` : "/api/events/";
}

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({ baseUrl }),
    tagTypes: ["Event"],
    endpoints: (builder) => ({
        getEvents: builder.query<Event[], EventsApiQuery>({
            query: (queryArg) => buildEventsPath(queryArg ?? {}),
            transformResponse: (response: PaginatedEvents | Event[]) =>
                Array.isArray(response) ? response : response.results,
            providesTags: (result) =>
                result
                    ? [
                          ...result.map(({ id }) => ({ type: "Event" as const, id })),
                          { type: "Event", id: "LIST" },
                      ]
                    : [{ type: "Event", id: "LIST" }],
        }),
        getEventById: builder.query<Event, number>({
            query: (id) => `/api/events/${id}/`,
            providesTags: (_result, _error, id) => [{ type: "Event", id }],
        }),
    }),
});

export const { useGetEventsQuery, useGetEventByIdQuery } = apiSlice;
export default apiSlice;
